import { withStyles } from "@material-ui/core";
import React from "react";

const styles = (theme) => ({
  details: {
    color: theme.TextColor,
    fontSize: 12,
  },
  value: {
    fontWeight: 600,
  },
});
const Details = ({ classes, label, value, containerClass }) => {
  return (
    <div className={`${classes.details} ${containerClass ?? ""}`}>
      <span>{label}</span>
      <span className={classes.value}>{value}</span>
    </div>
  );
};
export default withStyles(styles)(Details);
